import { combineReducers, type Reducer } from '@reduxjs/toolkit';

// Import helpers
import { getPersistState } from './helpers';

// IMPORT COMMON REDUCERS
import auth from './auth/auth_reducer';
import register from './register/register_reducer';
import reset_password from './reset_password/reset_password_reducer';
import email_confirmation from './email_confirmation/email_confirmation_reducer';
import portal from './portal/portal_reducer';
import player from './player/player_reducer';
import pip from './pip/pip_reducer';
import player_details from './player/player_details_reducer';
import player_vod from './player/player_vod_reducer';
import search from './search/search_reducer';
import parental_control from './parental_control/parental_control_reducer';
import user_products from './user_products/user_products_reducer';
import user_payments from './user_payments/user_payments_reducer';
import user_vod_accounts from './user_vod_accounts/user_vod_accounts_reducer';
import user_code_login from './user_code_login/user_code_login_reducer';
import previous_location from './prev_location';
import subscriptions from './subscriptions';
import static_documents from './static_documents/static_documents_reducer';
import documents from './documents/document_reducer';
import provider from './provider/provider_reducer';
import user_providers from './user_providers/user_providers_reducer';

// IMPORT RECORDING REDUCERS
import recordingsNpvr from './recordings/recordings_npvr_reducer';

// IMPORT TV REDUCERS
import tvReducers from './tv';

// IMPORT VOD REDUCERS
import vodReducers from './vod';

// IMPORT SECTIONS GROUP REDUCER
import sections from './sections_group/sections_group_reducer';

// IMPORT TRANSACTION REDUCERS
import transactionReducers from './transaction';

// Import api
import { api } from 'store/api';

const appReducer = combineReducers({
	auth,
	register,
	reset_password,
	provider,
	user_providers,
	portal,
	user_payments,
	player,
	player_details,
	player_vod,
	pip,
	parental_control,
	search,
	user_products,
	user_vod_accounts,
	user_code_login,
	previous_location,
	email_confirmation,
	recordingsNpvr,
	...tvReducers,
	sections,
	...vodReducers,
	...transactionReducers,
	...subscriptions,
	static_documents,
	documents,
	[api.reducerPath]: api.reducer
});

type State = ReturnType<typeof appReducer>;

const rootReducer: Reducer<State> = (state, action) => {
	if (action.type === 'SIGN_OUT') {
		const persistedState = getPersistState(state);
		return appReducer(persistedState, action);
	}

	return appReducer(state, action);
};

export default rootReducer;
